<template>
<div class="dashboard">
  <v-snackbar v-model="snackBarDialog" :timeout="3000" top>
    <span>{{ snackbarText }}</span>
    <v-btn flat color="white" @click="snackBarDialog=false">close</v-btn>
  </v-snackbar>
  <h1 class="subheading grey--text">Dashboard</h1>
    <v-container class="my-5">
      
      <v-layout row class="mb-3">
        <v-tooltip top>
          <v-btn flat small color="grey" slot="activator" @click="sortBy('title')">
            <v-icon left small>folder</v-icon>
            <span class="caption text-lowercase">by project name</span>
          </v-btn>
          <span>sort by title</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn flat small color="grey" slot="activator" @click="sortBy('person')">
            <v-icon left small>person</v-icon>
            <span class="caption text-lowercase">by person</span>
          </v-btn>
          <span>sort by name</span>
        </v-tooltip>

      </v-layout>

      <v-card flat v-for="customer in customers" :key="customer.stripe_id">
        <v-layout row wrap :class="`pa-3 ${customer.status} complete`">
          <v-flex xs4 md1>
            <div class="caption grey--text">Action</div>
            
            <!-- dropdown menu-->
            <v-menu auto offset-x open-on-hover>                
                <v-btn
                  slot="activator"
                  flat
                  color="grey"
                >
                <v-icon left>expand_more</v-icon>
                </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in items"
                  :key="index"
                  @click="actOnCustomer(item.title, customer.stripe_id)"
                >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

          </v-flex>
          <v-flex xs8 md3>
            <div class="caption grey--text">Customer</div>
            <div>{{customer.first}} {{customer.last}}</div> 
            <div class="grey--text"> {{customer.email}} </div>
          </v-flex>
          <v-flex xs6 sm3 md2>
            <div class="caption grey--text hidden-sm-and-down">Created</div>
            <div v-if="customer.date_created" class="grey--text mt-3 hidden-sm-and-down">{{ customer.date_created.getMonth() }}/{{ customer.date_created.getDate() }}/{{customer.date_created.getFullYear()}}</div>
            <div v-else class="grey--text mt-3 hidden-sm-and-down">--</div>
          </v-flex>
          <v-flex xs6 sm3 md2>
            <div class="caption grey--text hidden-sm-and-down">Due</div>
            <div v-if="customer.date_created" class="grey--text mt-3 hidden-sm-and-down">{{ customer.date_created.getMonth() }}/{{ customer.date_created.getDate()+customer.due_date }}/{{customer.date_created.getFullYear()}}</div>
            <div v-else class="grey--text mt-3 hidden-sm-and-down">--</div>
          </v-flex>
          <v-flex xs4 sm3 md1>
            <div class="right">
              <v-chip v-if="customer.status != null" :class="`complete white--text ${customer.status} caption my-3`"> {{customer.status }}</v-chip>
              <v-chip  outline color="grey lighten-1" small v-else :class="`complete white--text caption my-3`">no invoice</v-chip>
            </div>
          </v-flex>          
          <v-flex xs8 sm3 md3>
            <div class="caption grey--text right" v-if="customer.amount != null">Amount</div>
            <br>
            <div class="right"  v-if="customer.amount != null">${{customer.amount}}</div>
          </v-flex>

        </v-layout>
      <v-divider></v-divider>
      </v-card>

    </v-container>
    <v-dialog v-if="currentCustomer" v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add invoice item for {{ currentCustomer.first}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field 
                    label="Amount*" 
                    v-model="itemAmount"
                    hint="in dollars"
                    persistent-hint
                    prefix="$"
                    required>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Description*"
                  v-model="itemDescription"
                  hint="e.g. For March consulting"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" :loading="loading" flat @click="saveItemDialog">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</div>
</template>

<script>
  import db from '@/fb'
  import firebase from 'firebase'
  //require('firebase/auth')

  export default {
    data() {
      return {
        loading: false,
        dialog: false, 
        itemAmount: '',
        itemDescription: '',
        customers: [],
        currentCustomer: {},
        snackBarDialog: false,
        snackbarText: '',
        items: [
          { title: 'Start an invoice' },
          { title: 'Update invoice' },
          { title: 'Send invoice' },
          { title: 'Cancel invoice' },
          { title: 'Delete invoice' },
          { title: 'Delete Customer' },
        ]
      }
    },
    methods: {
      sortBy(category) {
        // TODO: sort by chrono/reverse chrono/amount
        this.customers.sort((a,b)=> a[category] < b[category] ? -1 : 1)
      },
      actOnCustomer(directive, sid) {
        // Get customer details and pass to currentCustomer
        let cust = this.customers.filter(customer => {
          return (customer.stripe_id==sid)
        })
        this.currentCustomer =cust[0]

        //DELETE CUSTOMER
        //TODO: Move this to customer view
        if (directive === 'Delete Customer') {
          if (confirm(`Delete customer: ${sid}`)) {            
            console.log ("delete", sid)
            let deleteCustomerFromStripe = firebase.functions().httpsCallable('deleteCustomer')
            deleteCustomerFromStripe({ sid })
            .then(response =>{
                console.log(`response from stripe: ${response.data.id}`)
  
                let deleteCustomerFromDb = db.collection('customers').where('stripe_id','==',sid);
                deleteCustomerFromDb.get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        doc.ref.delete();
                    })
                    console.log(`deleted ${sid} from db`)
                    this.customers = this.customers.filter(customer =>{
                        return customer.stripe_id !== sid
                    })
                    // this.$emit('addedCustomerSnackbar')
                    this.snackbarText = 'Deleted customer'
                    this.snackBarDialog = true;
                })
            })
            .catch(err =>{
              console.log(err)
            })
          }

        } 
        // CREATE A LINE ITEM
        // TODO this is going to be called start an invoice
        else if (directive=='Start an invoice') {
          this.dialog = true 
        }
        else if (directive=='Update invoice') {

        // customer: "cus_ECO3HTzwPNXJp0",
        // amount: 20000,
        // currency: "usd",
        // description: "from the server call",
        // invoice: "in_1EGaciGb2oFBFOxmjbEvlzA8"

          this.dialog = true
          console.log(this.currentCustomer.latest_invoice)
          // let addNewIvoiceItem = firebase.functions().httpsCallable('addInvoiceItemtoCustomer')
          // addNewIvoiceItem({
          //   customer: this.currentCustomer.stripe_id,
          //   amount: Number(this.itemAmount)*100,
          //   currency: "usd",
          //   description: this.itemDescription,
          //   invoice: "in_1EGaciGb2oFBFOxmjbEvlzA8"
          // })
          // .then (() => {
          //   console.log("updated invoice?")
          // })
          // .catch(err => {
          //   console.log(err)
          // })
        }

        else if (directive=='Cancel invoice') {
          this.doAnything()
        }
        else if (directive=='Send invoice') {

          let sendInvoiceFromStripe = firebase.functions().httpsCallable('sendInvoice')
          sendInvoiceFromStripe({invoice_id: this.currentCustomer.latest_invoice})
          .then (result => {
            console.log("sent the invoice, ", result)
            // TODO: clear latest_invoice from db
            // TODO: add snackbar
            this.snackbarText = `Sent invoice to ${this.currentCustomer.email}`
            this.snackBarDialog = true
            var docRef = db.collection('customers').doc(this.currentCustomer.id);
            docRef.update({
                latest_invoice: ''
            })
            this.removeLatestInvoiceFromCurrentCustomer(this.currentCustomer.id)                  
          })
          .catch (err => {
            console.log(err)
          })     
        }
      },
      saveItemDialog() {
        //TODO: handle close (not save) state
        //start saving routine, start save button animation
        this.loading = true

        //call stripe to add item function with invoice data from form

        if (this.currentCustomer.latest_invoice) {
          // create a line item on an EXISTING INVOICE
          console.log("current customer: ", this.currentCustomer)

          let addIvoiceItem = firebase.functions().httpsCallable('addInvoiceItemtoCustomer')
          addIvoiceItem({
            customer: this.currentCustomer.stripe_id,
            amount: Number(this.itemAmount)*100,
            currency: "usd",
            description: this.itemDescription,
            invoice: this.currentCustomer.latest_invoice
          })
          .then (() => {
            console.log("added value to invoice: ", this.itemAmount)
            this.loading = false
            this.dialog = false
            this.snackbarText = `Updated invoice with a $${this.itemAmount} item`
            this.snackBarDialog = true
            this.itemAmount = ''
            this.itemDescription = ''
            this.updateCustomerData()
          })

        } else {
          //create a line item on a NEW INVOICE
        
          let addIvoiceItem = firebase.functions().httpsCallable('addInvoiceItemtoCustomer')
          addIvoiceItem({
              customer: this.currentCustomer.stripe_id,
              amount: Number(this.itemAmount)*100,
              currency: "usd",
              description: this.itemDescription
            })
          //now that an item has been created in stripe, create a draft invoice
          .then( res => {
            // console.log("item successfully added, Stripe response: ", res.data)
            // console.log("create an invoice with ", this.currentCustomer.stripe_id)

            //call stripe to create draft invoice
            let draftInvoice = firebase.functions().httpsCallable('startDraftInvoice')
            draftInvoice({ stripe_id: this.currentCustomer.stripe_id})
            .then (response => {
              //console.log ('invoice id: ', response.data.id)

              //invoice status key: draft, sent, paid, overdue, deleted
              //update db with invoice data
              let uid = firebase.auth().currentUser.uid
              db.collection('invoices').add({
                uid,
                customer_id: this.currentCustomer.id,
                stripe_invoice_id: response.data.id,
                due_date: 3,
                status: 'draft',
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                amount: response.data.amount_due
              })
              .then (() => {
                //console.log("added invoice to db")
                //update customer with invoice id
                console.log("add new invoice id to customer: ", response.data.id)
                this.addLatestInvoiceToCustomerObject(response.data.id)
                console.log("added new invoice id to customer: ", this.currentCustomer.latest_invoice)
                //update customer in db with latest invoice id
                var docRef = db.collection('customers').doc(this.currentCustomer.id);
                docRef.update({
                    latest_invoice: response.data.id
                })
                .then (() => {
                  //console.log("updated customer in db with invoice id")
                  //clean up
                  // console.log("about to call current customer thingy")
                  // this.removeLatestInvoiceFromCurrentCustomer(this.currentCustomer.id)

                  this.loading = false
                  this.dialog = false
                  this.snackbarText = `Created an invoice for $${this.itemAmount}`
                  this.snackBarDialog = true
                  this.itemAmount = ''
                  this.itemDescription = ''
                  this.updateCustomerData()

                })
                
              })
              //TODO: not sure I need this
              .catch(err => {
                console.log(err)
              })
            })

          })
          .catch ( err => {
            console.log(err.data)
          })
        }
      },
      doAnything(){
        console.log("in do anything")
        this.updateCustomerData()
      },
      addLatestInvoiceToCustomerObject(iid) {
        this.customers.forEach(customer => {
          if (customer.id == this.currentCustomer.id ){
            customer.latest_invoice = iid
          }
        })
      },
      removeLatestInvoiceFromCurrentCustomer(id){
        console.log("in removeLatestInvoiceFromCurrentCustomer")
        this.customers.forEach(customer => {
          if (customer.id == id) {
            customer.latest_invoice =''
          }
        })
        // TODO: do I need this?
        return

      },
      updateCustomerData() {
        this.customers.forEach(customer =>{
          if (customer.latest_invoice) {
            console.log(customer.first, ': ', customer.latest_invoice)
            //let customerInvoice = db.collection('invoices').doc(customer.latest_invoice)

            db.collection('invoices').where('stripe_invoice_id', '==', customer.latest_invoice).get()
            .then (snapshot => {
              if (snapshot.empty) {
                console.log ("no invoice found")
              } else {
                // TODO: Error: Uncaught (in promise) TypeError: Cannot read property 'status' of undefined
                // TODO: Error: Uncaught (in promise) TypeError: Cannot read property 'data' of undefined
                
                snapshot.forEach(doc =>{
                  let date = new Date(Number(doc.data().timestamp.seconds)*1000);
                  customer.amount = doc.data().amount/100
                  customer.status = doc.data().status
                  customer.date_created = date
                  customer.due_date = doc.data().due_date
                  //console.log(customer.status, customer.amount, customer.due_date.getFullYear())
                })
              }
            })
          }
        })
      }
    },
    created() {
      //add 
      db.collection('customers').onSnapshot(res => {
        //console.log("updated customers from firestore")
        const changes = res.docChanges()
        changes.forEach(change => {
          if (change.type==="added") {
            this.customers.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
        })
        //console.log("first customers: ", this.customers)
        this.updateCustomerData()
        //console.log("second customers: ", this.customers)
        
      })
    },
    mounted() {
      console.log("in mounted: ", this.customers)
      //this.updateCustomerData()
    }
  }
</script>

<style>
  .row.sent{
    border-left: 4px solid #3CD1C2;
  }
  .row.draft{
    border-left: 4px solid orange
  }
  .project.overdue{
    border-left: 4px solid tomato;
  }
  .v-chip.sent{
    background: #3cd1c2;
  }
  .v-chip.draft{
    background: #ffaa2c;
  }
  .v-chip.overdue{
    background: #f83e70;
  }
</style>
